import D2C_HostCloud from './Cloud'

class D2C_HostVultr extends D2C_HostCloud {
  static objectType = 'hostType'
  static active = true
  static providerType = 'Vultr'
  static color = '#0077ff'
  static fields = {
    ...D2C_HostCloud.fields,
    labels: {
      ...D2C_HostCloud.fields.labels,
      width: 12,
    },
    backup: {
      default: false,
      label: 'Backup',
      path: 'backup',
      required: false,
      width: 4,
      enum: [
        {value: true, text: 'ON'},
        {value: false, text: 'OFF'},
      ],
      validate() {
        return null
      },
      creating: {},
    },
    instance: {
      ...D2C_HostCloud.fields.instance,
      reversible: false,
      reversibleReadonly: true,
    },
  }
}

export default D2C_HostVultr
